export const BOTTOMSHEET_CLOSE_GA_SELECTOR = 'survey_modal_close'
export const BOTTOMSHEET_SUBMIT_GA_SELECTOR = 'survey_modal_response'
